
import React from 'react';
import { Clock, User, Wrench } from 'lucide-react';
import { MaintenanceHistoryItem } from './hooks/useMaintenanceHistory';

interface MaintenanceHistoryTimelineProps {
  maintenanceHistory: MaintenanceHistoryItem[];
}

const MaintenanceHistoryTimeline: React.FC<MaintenanceHistoryTimelineProps> = ({ maintenanceHistory }) => {
  return (
    <div className="relative">
      <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-gray-200 dark:bg-gray-700"></div>
      {maintenanceHistory.map((item, index) => (
        <div key={index} className="relative pl-10 pb-6">
          <div className="absolute left-2 top-2 rounded-full w-5 h-5 bg-primary border-4 border-white dark:border-gray-900"></div>
          <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 border">
            <div className="flex justify-between items-start">
              <div>
                <h3 className="font-medium">{item.action}</h3>
                <div className="flex items-center text-sm text-muted-foreground mt-1">
                  <User className="h-3.5 w-3.5 mr-1" />
                  <span>{item.technician}</span>
                  <Clock className="h-3.5 w-3.5 ml-3 mr-1" />
                  <span>{new Date(item.date).toLocaleDateString()}</span>
                </div>
              </div>
              <span className={`text-xs px-2 py-1 rounded ${
                item.status === 'Completed' 
                  ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400' 
                  : 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400'
              }`}>
                {item.status}
              </span>
            </div>
            <div className="mt-2 text-sm">
              <div className="flex items-start">
                <Wrench className="h-3.5 w-3.5 mr-1 mt-0.5 text-muted-foreground" />
                <span>{item.findings}</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MaintenanceHistoryTimeline;
